<template>
  <div class="login">
    <img class="logo-name" src="../../../assets/images/login/logo-name.png" alt>
    <div class="login-content">
      <div class="form-container">
        <div>
          <div>
            <p class="sub-title">登录到</p>
            <p class="sub-title">仓配数字化运控系统</p>
          </div>
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            auto-complete="on"
            label-position="left"
          >
            <el-form-item prop="username">
              <span class="svg-container">
                <img src="../../../assets/images/login/userName.png">
              </span>
              <el-input
                ref="username"
                v-model="loginForm.username"
                type="text"
                placeholder="请输入用户名"
                @keyup.enter.native="loginIn('loginForm')"
              />
            </el-form-item>
            <el-form-item prop="password">
              <span class="svg-container">
                <img src="../../../assets/images/login/passWord.png">
              </span>
              <el-input
                ref="password"
                v-model="loginForm.password"
                @keyup.enter.native="loginIn('loginForm')"
                type="password"
                placeholder="请输入密码"
              />
            </el-form-item>
            <el-button
              type="primary"
              class="login-btn"
              @click.native.prevent="loginIn('loginForm')"
              >登录</el-button
            >
          </el-form>
        </div>
        <p class="tips">如若忘记密码，请主动联系运营人员</p>
      </div>
    </div>
    <div class="copy">浙ICP备2021015260号-2| 2022 杭州数创智慧网络科技有限公司所有</div>
  </div>
</template>

<script>
import User from "models/user";
const user = new User();
import MENU_LIST from "@/common/menu/menu.js";
import { saveToken, saveDBUserRealName, deleteToken, saveUrl, saveSetFlag, saveUserSetHome, saveUserSetHomeKeyWord } from "common/js/storage";
export default {
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword }
        ],
      },
    };
  },

  methods: {
    loginIn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let username = this.loginForm.username
          let password = this.loginForm.password
          let data = {
            username,
            password
          };
          user.postUserLogin(data).then(res => {
            if (res.success) {
              deleteToken()
              saveToken(res.result.token);
              saveDBUserRealName(res.result.username);
              saveUrl('home')
              this.initLoginInfo()
            } else {
              this.$message.error(res.message)
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    initLoginInfo() {
      user.getLoginInfo().then(res => {
        if (res.success) {
          let { isAuthorized, homePageSetting } = res.result
          saveSetFlag(isAuthorized);
          if (homePageSetting) {
            let obj = MENU_LIST[homePageSetting]
            saveUserSetHome(obj.url)
            saveUserSetHomeKeyWord(homePageSetting)
            this.$router.replace(obj.url);
          } else {
            saveUserSetHome('')
            saveUserSetHomeKeyWord(homePageSetting)
            this.$router.replace("/home");
          }
        } else {
          this.$message.error(res.message)
        }
      });
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/style/layout/login.scss';
</style>
